import React from "react";
import {VehicleGroup, VehicleGroupNames} from "../../../../../model/vehicle";
import "./MtplVehicleGroupComponentStyles.scss";
import {VehicleGroupSVG} from "../../../../../components/VehicleGroupSvg";
import {format} from "../../../../../utils/format";

interface MTPLVehicleGroupComponent {
    vehicleGroup: VehicleGroup;
    plateNumber: string;
}

export const MTPLVehicleGroupComponent = ({vehicleGroup, plateNumber}: MTPLVehicleGroupComponent) => {
    return (
        <div className={"mtpl-vehicle-group-component"}>
            <div className={"mtpl-vehicle-group-component__image"}>
                <VehicleGroupSVG vehicleGroup={vehicleGroup}/>
            </div>

            <div className="mtpl-vehicle-group-component__info">
                <div
                    className={`mtpl-vehicle-group-component__label${plateNumber ? ' mtpl-vehicle-group-component__label--small' : ''}`}>
                    <span>{VehicleGroupNames[vehicleGroup]}</span>
                </div>

                <div className={"mtpl-vehicle-group-component__plate-number"}>
                    {plateNumber && format(plateNumber, '## #### ##')}
                </div>
            </div>
        </div>
    );
};